export class USERACTIVITYLOG {
    accessedMessage: string;
    accessedMessageId: string;
    isCategory: string;
}
